<template>
  <v-app>
    <v-app-bar app dark flat color="primary">
      <template v-if="userClients != undefined && userClients.length > 1">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              v-bind="attrs"
              v-on="on"
            >
              {{ selectedClient.Name }}
              <v-icon right dark>
                mdi-cog
              </v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item
                v-for="(item, index) in userClients"
                :key="index"
              >
                <v-list-item-title @click="changeSelectedClient(item.ClientID)">{{ item.Name }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </template>
      
      <div class="align-center text-h5 px-3">{{currentRouteName}}</div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <navigation-drawer></navigation-drawer>

    <v-main>
      <div class="d-flex flex-column justify-space-between fill-height">
        <router-view/>

        <v-sheet class="grey lighten-5 py-2">
        
          <div class="d-flex justify-space-between mx-2">
            <span class="text-caption">
              {{environment}} v{{versionNumber}}
            </span>
            <span class="text-right text-caption">
              © ServiceFM 2022
            </span>
          </div>
        </v-sheet>
      </div>
    </v-main>

  </v-app>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import NavigationDrawer from "./components/global/navigationDrawer.vue"
import { vxm } from '@/store/index';

@Component({
  components: {
    NavigationDrawer,
  }
})

export default class ClientPortalApp extends Vue {
  private versionNumber = process.env.VUE_APP_VERSION;
  private environment = process.env.VUE_APP_ENVIRONMENT;

  private get currentRouteName() {
    return this.$route.meta?.title != null ? this.$route.meta?.title : this.$route.name;
  }
  get selectedClient() { return  vxm.AuthStore.targetClient; }
  get userClients() {
    if(vxm.AuthStore.user === null || vxm.AuthStore.user === undefined) {
      return []
    }
    return vxm.AuthStore.user!.Clients
  }

  changeSelectedClient(clientID: string){
    vxm.AuthStore.setTargetClient(clientID)
  }
}
</script>

<style lang="scss">
  $font-family: "Arial" ;
  .filter
  {
    padding-left: 10px;
    padding-right: 10px;  
  }
  .v-application {
  [class*="text-"] {
    font-family: $font-family, sans-serif !important;
  }
  font-family: $font-family, sans-serif !important;
  }
  .v-data-table-header th {
    height: 60px !important;
    font-weight: 700 !important;
    font-size: 16px !important;        
    background-color: #eaecee;
  }
  .v-data-table {
      box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%) !important;
  }
  .v-data-table > .v-data-table__wrapper tbody tr.v-data-table__expanded__content {
    background: #f5f5f5;
  }
  .v-main {
    background: #fafafa;
  }
</style>